import { Button, Paper, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import OneSelect from "../../OneSelect/OneSelect"
import OneTextArea from "../../OneTextArea/OneTextArea"
import { useContext, useEffect, useState } from "react"
import { CondominiosContext } from "../../../Providers/CondominiosContext/CondominiosContext"
import { WebSocketContext } from "../../../Providers/WebSocket/WebSocketContext"
import { tiposOcorrencias } from "../../../Utils/optionsSelects"
import OneInput from "../../OneInput/OneInput"
import { OneSwitch } from "../../OneSwitch/OneSwitch"
import { showNotify } from "../../../Utils/Utils"
import ComboBox from "../../ComboBox/ComboBox"

const newSx = {
    input: {
        height: { xs: '30px', lg: '21px', xl: '30px' },
        fontSize: { lg: '10px', xl: '15px' }
    },
    label: {
        fontSize: { lg: '13px', xl: '15px' }
    }
}

const CriarEditarLivroAta = ({ idEdit, setIdEdit, setAcao }) => {
    const { condominios } = useContext(CondominiosContext)
    const optionsCondominios = condominios.map((condominio) => {
        return { nome: `${condominio.id_central}-${condominio.nome} `, id_central: condominio.id_central }
    })
    const { addRoute, sendWs } = useContext(WebSocketContext)

    const [formData, setFormData] = useState({})
    // useEffect(() => {
    //     if (activeCond.id_central) {
    //         formData.id_central = activeCond.id_central
    //     }
    // }, [])
    const [initialData, setInitialData] = useState()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        if (idEdit) {
            addRoute("buscarObsLivroAta", (msg) => {
                if (msg.error) {
                    showNotify("error", msg.error)
                } else {
                    let obs = msg.data.obs
                    if (obs.data_obs) {
                        obs.hora = obs.data_obs.split("T")[1].split('.')[0]
                        obs.data_obs = obs.data_obs.split("T")[0]
                    }
                    setInitialData(obs)
                    setAcao('editar')
                    setFormData(obs)
                    setLoading(false)
                }
            })
            sendWs("buscarObsLivroAta", { id: idEdit })
        } else {
            setLoading(false)
        }
    }, [idEdit])

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const getCriarAta = (msg) => {
        if (msg.error) {
            showNotify("error", msg.error)
            setLoading(false)
            return
        } else {
            showNotify("success", "Observação criada com sucesso")
            setFormData({})
        }
        setLoading(false)
    }

    const getEditarAta = (msg) => {
        if (msg.error) {
            showNotify("error", msg.error)
            setLoading(false)
            return
        } else {
            showNotify("success", "Observação editada com sucesso")
            setFormData({})
            setInitialData({})
            setAcao('insere')
        }
        setLoading(false)
    }

    addRoute("criarObsLivroAta", getCriarAta)
    addRoute("editarObsLivroAta", getEditarAta)
    const handleSubmit = () => {
        if (!formData.id_central) {
            showNotify("warning", "Selecione um condomínio")
            return
        }
        if (!formData.texto) {
            showNotify("warning", "É necessário preencher o texto")
            return
        }

        if (formData.gerar_evento && !formData.data_obs) {
            showNotify("warning", "É necessário preencher a data ou desativar o agendamento de evento")
            return
        }

        if (!formData.data_obs && formData.hora) {
            delete formData.hora
        }
        let data = formData

        if (data.data_obs) {
            if (data.hora) {
                data.data_obs = `${data.data_obs} ${data.hora}`
                delete data.hora
            } else {
                data.data_obs = `${data.data_obs} 00:00:00.000`
                data.SEM_HORA = true
            }
        } else {
            data.SEM_DATA = true
            data.SEM_HORA = true
        }
        if (!data.tipo) {
            data.tipo = 1
        }
        setLoading(true)
        if (idEdit) {
            data.id = idEdit
            sendWs('editarObsLivroAta', { observacao: data })
        } else {
            sendWs('criarObsLivroAta', { observacao: data })
        }
    }

    const limparDados = () => {
        setFormData({})
        setInitialData({})
        setIdEdit()
        setLoading(true)
        setAcao('insere')
        setTimeout(() => {
            setLoading(false)
        }, 100)
    }

    return (
        <>
            <Paper sx={{
                backgroundColor: '#D9D9D9',
                width: '100%',
                padding: '3px 10px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100%'
            }}>
                {!loading &&
            <>
                <Grid container spacing={1} xs={12} sx={{ margin: 0, padding: 0, alignItems: 'center' }}>
                    <Grid xs={1} lg={0.7} xl={0.7} >
                        <Typography sx={newSx.label} >Tipo: </Typography>
                    </Grid>
                    <Grid xs={3} lg={2}>
                        <OneSelect
                            newSx={newSx.input}
                            options={tiposOcorrencias}
                            defaultValue={initialData?.tipo || tiposOcorrencias[0].id}
                            name="tipo"
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid xs={3} lg={2} xl={2.5}>
                        <Typography sx={newSx.label} >Cond./Empresa: </Typography>
                    </Grid>
                    <Grid xs>
                        <ComboBox
                            newSx={newSx.input}
                            options={optionsCondominios}
                            defaultValue={initialData?.id_central}
                            label="nome"
                            valor="id_central"
                            name="id_central"
                            onChange={handleChange}
                            separado={true}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1} xs={12} sx={{ margin: 0, padding: 0, alignItems: 'center' }}>
                    <Grid xs={1} lg={0.7} xl={0.7} >
                        <Typography sx={newSx.label} >Data: </Typography>
                    </Grid>
                    <Grid xs={3} lg={2} xl={1.7} >
                        <OneInput
                            newSx={newSx.input}
                            defaultValue={initialData?.data_obs}
                            type="date"
                            name="data_obs"
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid xs={1} lg={0.7} xl={0.5}>
                        <Typography sx={newSx.label} >Hora: </Typography>
                    </Grid>
                    <Grid xs={2} lg={1.2} xl={1} >
                        <OneInput
                            newSx={newSx.input}
                            defaultValue={initialData?.hora}
                            type="time"
                            name="hora"
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid xs={3} lg={2} xl={1.5}>
                        <Typography sx={newSx.label} >Agendar Evento </Typography>
                    </Grid>
                    <Grid xs={1} lg={0.6} xl={1}>
                        <OneSwitch
                            defaultValue={initialData?.gerar_evento}
                            name="gerar_evento"
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid xs={3} lg={3} xl={1.7}>
                        <Typography sx={newSx.label} >Repetir diariamente</Typography>
                    </Grid>
                    <Grid xs={1} lg={0.6} xl={0.5} >
                        <OneSwitch
                            defaultValue={initialData?.repetir_diariamente}
                            name="repetir_diariamente"
                            onChange={handleChange}
                        />
                    </Grid>
                    {/* mudar quando implantar back */}
                    <Grid sx={{ display: 'none' }} xs={3} lg={2.1} xl={1.5}>
                        <Typography sx={newSx.label} >Avisar Whatsapp </Typography>
                    </Grid>
                    <Grid sx={{ display: 'none' }} xs={1} lg={0.7} xl={0.5} >
                        <OneSwitch
                            defaultValue={initialData?.avisa_whats}
                            name="avisa_whats"
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid xs lg xl sx={{ display: 'none' }} >
                        <OneInput
                            newSx={newSx.input}
                            defaultValue={initialData?.number_whats}
                            placeholder="(xx)xxxxx-xxxx"
                            name="number_whats"
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1} xs={12} sx={{ margin: 0, padding: 0, alignItems: 'flex-start' }}>
                    <Grid xs={1} lg={0.7} xl={0.7}>
                        <Typography sx={newSx.label} >Texto: </Typography>
                    </Grid>
                    <Grid xs lg xl height={"40px"}>
                        <OneTextArea
                            defaultValue={initialData?.texto}
                            name="texto"
                            onChange={handleChange}
                        />
                    </Grid>
                </Grid>
                <Grid container xs={12} sx={{ margin: 0, padding: 0, justifyContent: 'end' }}>
                    <Button variant="contained" color="one_primary" sx={{ mr: '40px', height: { lg: '20px', xl: '30px' }, fontSize: { lg: '11px', xl: '14px' } }} onClick={limparDados} >Cancelar</Button>
                    <Button variant="contained" color="one_primary" sx={{ height: { lg: '20px', xl: '30px' }, fontSize: { lg: '11px', xl: '14px' } }} onClick={handleSubmit} >Salvar</Button>
                </Grid>
            </>
                }
            </Paper>
        </>
    )
}

export default CriarEditarLivroAta
